module.exports = __webpack_public_path__ + "static/media/hand-3108158_1920.8c79312b.jpg";